import React from 'react';

import { AdvanceItem, AdvanceTitle, SquareButton, Icon, CircleButton, InputTitleBlock, Title } from '../styled';

import deleteIcon from '../../../static/img/icon-bin.svg';
import arrowIcon from '../../../static/img/icon-chevron.svg';
import { createKey } from '../../../utils';
import Tooltip from '../../UI/Tooltip/Tooltips';

const TranscriptInputTab = ({
  createBubbleTextRequest,
  handleBubbleTextRequest,
  handleDeleteTranscript,
  inputTypeMap,
  isShowTranscriptListTab,
  setIsShowTranscriptListTab,
  transcriptConfig,
  updateBubbleTextRequest,
}) => {
  const handleReturnToList = (isSave) => {
    setIsShowTranscriptListTab(!isShowTranscriptListTab);
    if (isSave) {
      handleBubbleTextRequest();
    }
  };

  return (
    <>
      <Title lineHeight="1.9rem" margin="0 0 0.4rem 0">
        {createBubbleTextRequest ? 'Create' : 'Edit'} Transcript
      </Title>
      <InputTitleBlock>
        <div style={{ display: 'flex' }}>
          <CircleButton
            backgroundColor="#e1e1e1"
            color="black"
            height="1.9rem"
            transform="rotate(90deg)"
            type="button"
            width="1.9rem"
            onClick={() => handleReturnToList(false)}
          >
            <Icon title="left arrow" width="1.9rem">
              <img alt="Save transcript" src={arrowIcon} />
            </Icon>
          </CircleButton>
          <Title lineHeight="1.9rem" margin="0 0 0 .9rem">
            Back
          </Title>
        </div>
        <div style={{ display: 'flex' }}>
          <Title color="#505354" lineHeight="1.9rem" margin="0 0.9rem 0 0">
            Save
          </Title>
          <CircleButton
            backgroundColor="#e1e1e1"
            color="black"
            height="1.9rem"
            transform="rotate(270deg)"
            type="button"
            width="1.9rem"
            onClick={() => handleReturnToList(true)}
          >
            <Icon title="right arrow" width="1.9rem">
              <img alt="Back to transcript list" src={arrowIcon} />
            </Icon>
          </CircleButton>
          {updateBubbleTextRequest && (
            <SquareButton height="1.9rem" margin="0 0 0 0.9rem" type="button" width="1.9rem" onClick={handleDeleteTranscript}>
              <img alt="Delete the transcript" src={deleteIcon} />
            </SquareButton>
          )}
        </div>
      </InputTitleBlock>
      {transcriptConfig.map(({ title, labelText, tooltip, inputType, isHidden = false, ...otherTranscriptConfigProps }) => {
        const id = createKey(title ?? labelText);
        const InputComponent = inputTypeMap[inputType];

        if (isHidden) return <></>;

        return (
          <AdvanceItem key={id}>
            <AdvanceTitle>
              <Title>{title ?? labelText}</Title>
              <Tooltip text={tooltip} />
            </AdvanceTitle>
            <InputComponent
              {...otherTranscriptConfigProps}
              id={id}
              name={`${inputType}-${id}`}
              onChange={({ target: { name, checked, value } }) => {
                if (inputType === 'checkbox') {
                  otherTranscriptConfigProps.onChangeHandler(name, checked);
                } else {
                  otherTranscriptConfigProps.onChangeHandler?.(name, value);
                  otherTranscriptConfigProps.isChanged?.(value);
                }
              }}
            />
          </AdvanceItem>
        );
      })}
    </>
  );
};

export default TranscriptInputTab;
